import en_GB from "antd/lib/locale/en_GB";
import ar_EG from "antd/lib/locale/ar_EG";
import ur_PK from "antd/lib/locale/ur_PK";
import trans_en from "../translations/en";
import trans_ar from "../translations/ar";
import trans_ur from "../translations/ur";

// Register each portal language here. The backend only stores the code.
// catalogLanguage selects the existing English or Arabic business-data fields.
export const DEFAULT_PORTAL_LANGUAGE = "en";

const PORTAL_LANGUAGE_CONFIG = {
  en: {
    label: "English",
    i18nLanguage: "en-GB",
    direction: "ltr",
    catalogLanguage: "en",
    antdLocale: en_GB,
    translation: trans_en,
    fontFamily: "var(--font-family-en)",
  },
  ar: {
    label: "العربية",
    i18nLanguage: "ar-EG",
    direction: "rtl",
    catalogLanguage: "ar",
    antdLocale: ar_EG,
    translation: trans_ar,
    fontFamily: "var(--font-family-ar)",
  },
  ur: {
    label: "اردو",
    i18nLanguage: "ur-PK",
    direction: "rtl",
    catalogLanguage: "ar",
    antdLocale: ur_PK,
    translation: trans_ur,
    fontFamily: "var(--font-family-ur)",
  },
};

export const PORTAL_LANGUAGES = Object.entries(PORTAL_LANGUAGE_CONFIG).map(
  ([code, config]) => ({ code, ...config }),
);

export const isPortalLanguage = (code) =>
  Object.prototype.hasOwnProperty.call(PORTAL_LANGUAGE_CONFIG, code);

export const getPortalLanguageConfig = (code) =>
  isPortalLanguage(code)
    ? PORTAL_LANGUAGE_CONFIG[code]
    : PORTAL_LANGUAGE_CONFIG[DEFAULT_PORTAL_LANGUAGE];
